export default __webpack_public_path__ + "static/media/WorkOrders.aeac075b.svg";